'use strict';

const footerLabelBreakPattern = /<br\s*\/?>/gi;

export const splitFooterLabel = (value = '') => String(value ?? '').split(footerLabelBreakPattern);
